import { useState } from "react";

// Google Form entry IDs
const ENTRY_FIRST_NAME = 'entry.1267128207';
const ENTRY_LAST_NAME  = 'entry.328916428';
const ENTRY_EMAIL      = 'entry.807446159';
const ENTRY_POSTALCODE = 'entry.1991541731';

const GOOGLE_FORM_ACTION =
  'https://docs.google.com/forms/d/e/1FAIpQLScbUvKPLXj1GSKTObMFX1zQZp6ILauhjS6RLpC1iBgmHWbCrg/formResponse';

function InputField({ placeholder, name, value, onChange }: { placeholder: string; name: string; value: string; onChange: (e: React.ChangeEvent<HTMLInputElement>) => void }) {
  return (
    <div className="flex-1 w-full relative">
      <div className="bg-[#002d61] rounded-[8px] relative border border-[rgba(0,0,0,0.5)]">
        <input
          type={placeholder === "Email Address" ? "email" : "text"}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          required
          className="font-['Geist:Regular',_sans-serif] font-normal leading-[28px] md:leading-[32px] bg-transparent border-none outline-none text-[16px] md:text-[20px] text-[rgba(255,255,255,0.7)] placeholder:text-[rgba(255,255,255,0.7)] w-full px-[16px] md:px-[24px] py-[12px] md:py-[14px] rounded-[8px]"
        />
      </div>
    </div>
  );
}

export default function SignupSection() {
  const [formData, setFormData] = useState({ firstName: '', lastName: '', postalCode: '', email: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;

    // Basic validation
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.postalCode) {
      setStatusMessage('❌ Please fill in all fields.');
      return;
    }

    setIsSubmitting(true);
    setStatusMessage('');

    const payload = new URLSearchParams();
    payload.append(ENTRY_FIRST_NAME,  formData.firstName);
    payload.append(ENTRY_LAST_NAME,   formData.lastName);
    payload.append(ENTRY_EMAIL,       formData.email);
    payload.append(ENTRY_POSTALCODE,  formData.postalCode);

    try {
      await fetch(GOOGLE_FORM_ACTION, {
        method:  'POST',
        mode:    'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    payload.toString(),
      });

      // Reset form and show success message
      setFormData({ firstName: '', lastName: '', postalCode: '', email: '' });
      setStatusMessage('✅ Thank you! Your response was submitted.');
    } catch (err) {
      console.error('Google Form error:', err);
      setStatusMessage('❌ Submission failed. Please try again.');
    }

    setIsSubmitting(false);
  };

  return (
    <section id="signup" className="bg-[#003776] relative w-full" data-name="Signup">
      <div className="flex flex-col items-center justify-center w-full">
        <form onSubmit={handleSubmit} className="box-border content-stretch flex flex-col gap-[30px] md:gap-[40px] items-center justify-center px-4 md:px-16 lg:px-[300px] py-10 md:py-16 lg:py-[100px] relative w-full">
          <div className="content-stretch flex flex-col gap-[10px] md:gap-[14px] items-center relative shrink-0 text-center text-white w-full">
            <p className="font-['Geist:Medium',_sans-serif] font-medium leading-[32px] md:leading-[48px] lg:leading-[54px] w-full relative shrink-0 text-[28px] md:text-[48px] lg:text-[54px] tracking-[-1.62px]">Join Us</p>
            <p className="font-['Geist:Regular',_sans-serif] font-normal leading-[20px] md:leading-[24px] relative shrink-0 text-[14px] md:text-[16px] tracking-[-0.32px] w-full max-w-[559px] px-2 md:px-0">Sign up below to show your support and stay informed about Project Ontario</p>
          </div>
          <div className="w-full max-w-[840px] mx-auto">
            <div className="content-stretch flex flex-col gap-[16px] md:gap-[24px] items-start relative shrink-0 w-full">
              <div className="content-stretch flex flex-col md:flex-row gap-[16px] md:gap-[20px] items-start relative shrink-0 w-full">
                <InputField placeholder="First Name" name="firstName" value={formData.firstName} onChange={handleInputChange} />
                <InputField placeholder="Last Name" name="lastName" value={formData.lastName} onChange={handleInputChange} />
              </div>
              <div className="content-stretch flex flex-col md:flex-row gap-[16px] md:gap-[20px] items-start relative shrink-0 w-full">
                <InputField placeholder="Postal Code" name="postalCode" value={formData.postalCode} onChange={handleInputChange} />
                <InputField placeholder="Email Address" name="email" value={formData.email} onChange={handleInputChange} />
              </div>
            </div>
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-white box-border content-stretch flex flex-col items-center overflow-clip px-[14px] py-[4px] relative rounded-[1000px] shrink-0 hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <p className="font-['Geist:Bold',_sans-serif] font-bold leading-[32px] relative shrink-0 text-[#00499d] text-[16px] text-nowrap whitespace-pre">
              {isSubmitting ? 'Submitting...' : 'Sign Up'}
            </p>
          </button>
          {statusMessage && (
            <p className="text-center text-sm md:text-base text-white font-medium">
              {statusMessage}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
